import { createContext } from "react";
import { RowStore } from "../../store";

export const RowContext = createContext<RowStore | null>(null);
